import { render, staticRenderFns } from "./DotsSlider.vue?vue&type=template&id=0455743b&scoped=true"
import script from "./DotsSlider.vue?vue&type=script&lang=js"
export * from "./DotsSlider.vue?vue&type=script&lang=js"
import style0 from "./DotsSlider.vue?vue&type=style&index=0&id=0455743b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0455743b",
  null
  
)

export default component.exports